module.exports = __webpack_public_path__ + "static/media/aldi5.77277b6a.jpg";